import { useSelector } from 'hooks/utils';
import { selectCurrentUserEmail } from 'store/account/subscription';

export function useUserEmail() {
	return useSelector(state => selectCurrentUserEmail(state.account.subscription));
}
